/* eslint-disable */
import * as shared from '../shared';

googletag.cmd.push(function () {
  // institution_search_result_top
  googletag.defineSlot(
    '/21678620621/medicalnote_sp_hospital_search_top_20210330',
    shared.spTopSizes(),
    'div-gpt-ad-1617202765693-0'
  ).addService(googletag.pubads());

  // institution_search_result_middle_1
  googletag.defineSlot(
    '/21678620621/medicalnote_sp_hospital_search_feed1_20210330',
    shared.spBottomSizes(),
    'div-gpt-ad-1617202845106-0'
  ).defineSizeMapping(shared.setDfpResponsiveSize()).addService(googletag.pubads());

  // institution_search_result_middle_2
  googletag.defineSlot(
    '/21678620621/medicalnote_sp_hospital_search_feed2_20181003',
    shared.spBottomSizes(),
    'div-gpt-ad-1538559064907-0'
  ).defineSizeMapping(shared.setDfpResponsiveSize()).addService(googletag.pubads());

  shared.setDiseaseKeyValue();
  shared.setSymptomKeyValue();
  shared.setContentTypeKeyValue();
  shared.setHospitalDepartmentKeyValue();
  shared.setEnvKeyValue();
  shared.setAdTagKeyValue();
  shared.setPathKeyValue();
  shared.setDoctorKeyValue();

  if (!shared.isMobile()) googletag.pubads().enableSingleRequest();
  googletag.pubads().collapseEmptyDivs();
  googletag.enableServices();
});
/* eslint-enable */
